var map = {
	"./aida.png": 361,
	"./allfunds-connect.png": 362,
	"./bankit.png": 363,
	"./bnp-neolink.png": 364,
	"./cityvelocity.png": 365,
	"./credem.png": 366,
	"./eif-efront.png": 367,
	"./euribor-eu.png": 368,
	"./fdg-mcc.png": 369,
	"./fdg-sace.png": 370,
	"./feeonly-8a+.png": 371,
	"./feeonly.png": 372,
	"./google-calendar.png": 373,
	"./google-chat.png": 374,
	"./google-docs.png": 375,
	"./google-drive.png": 376,
	"./google-forms.png": 377,
	"./google-keep.png": 378,
	"./google-mail.png": 379,
	"./google-meet.png": 380,
	"./google-sheets.png": 381,
	"./google-slides.png": 382,
	"./infocamere.png": 383,
	"./matrix_ms.png": 384,
	"./normattiva.png": 385,
	"./pec-aruba.png": 386,
	"./podessys.png": 387,
	"./sgss.png": 388,
	"./six-telekurs.png": 389,
	"./statpro-revolution.png": 390,
	"./tmf-group.png": 391,
	"./whatsapp.png": 392,
	"./wolters-kluwer.png": 393
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 360;